import { useEffect } from "react";

// Pauses Lenis smooth-scroll while a modal/overlay is open so wheel/touch
// events don't scroll the page behind it.
export function useLenisLock(active) {
  useEffect(() => {
    if (!active) return;
    const lenis = window.__lenis;
    lenis?.stop();
    return () => lenis?.start();
  }, [active]);
}
